import { Body2 } from '@cian/ui-kit';
import { TColors } from '@cian/ui-kit-design-tokens/colors';
import React, { useMemo, FC } from 'react';

import styles from './Description.css';

interface IDescriptionProps {
  color?: TColors;
  text: string;
  lines?: number;
  isCoworking?: boolean;
}

export const CSS_LINE_HEIGHT = 20;

export const Description: FC<IDescriptionProps> = ({ text, lines, color, isCoworking }) => {
  const inlineStyles = useMemo(
    () =>
      lines
        ? {
            maxHeight: lines * CSS_LINE_HEIGHT,
            WebkitLineClamp: lines,
          }
        : {},
    [lines],
  );

  const className = isCoworking ? `${styles['description']} ${styles['description-coworking']}` : styles['description'];

  return (
    <div className={className} style={inlineStyles}>
      <Body2 color={color}>{text}</Body2>
    </div>
  );
};
